import { createSlice } from "@reduxjs/toolkit";
import {      reKyc_branchDetailsThunk } from "./thunk";

export const initialState = {
  reKyc_branchDetailsData: [],
  reKyc_branchDetailsError: '', 
  reKyc_branchDetailsLoading: false,
  };

const Re_Kyc_Fetch_Branch_Details = createSlice({
  name: "Re_Kyc_Fetch_Branch_Details",
  initialState, 
  reducers: {
    clearBranchDetails: (state) => {
      state.reKyc_branchDetailsData = null;   // ✅ reset bank data
      state.reKyc_branchDetailsError = '';    
    },
  }, 
  extraReducers: (builder) => {

    builder.addCase(reKyc_branchDetailsThunk.pending, (state) => {
      state.reKyc_branchDetailsLoading = true ;
      state.reKyc_branchDetailsData= [];
      state.reKyc_branchDetailsError='';

  });
    builder.addCase(reKyc_branchDetailsThunk.fulfilled, (state, action) => {
        state.reKyc_branchDetailsData = action.payload.data;
        state.reKyc_branchDetailsLoading = false ;
    });
    builder.addCase(reKyc_branchDetailsThunk.rejected, (state, action) => {
      state.reKyc_branchDetailsError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.reKyc_branchDetailsLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  clearBranchDetails,
  
} = Re_Kyc_Fetch_Branch_Details.actions

export default Re_Kyc_Fetch_Branch_Details.reducer;